export default {
  name      : 'OfferCard',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    item: {
      type   : Object,
      default: () => {
        return {
          Name         : '',
          Desc         : '',
          OriginalPrice: '',
          OfferPrice   : '',
          Image        : ''
        }
      }
    },

    hover: {
      type   : Boolean,
      default: false
    }

  },
  enums: {},
  data() {
    return {}
  },
  computed: {
    imageHeight() {
      if (this.$vuetify.breakpoint.xs) return 110
      if (this.$vuetify.breakpoint.sm) return 165
      if (this.$vuetify.breakpoint.md) return 180
      if (this.$vuetify.breakpoint.lg) return 240

      return 260
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
